import React from "react";

function CalendarSelector({
  calendars,
  selectedCalendars,
  setSelectedCalendars,
  calendarView,
  setCalendarView,
  setSelectedDate,
}) {
  const handleChange = (calendarId) => {
    //EventCard ? !EventCard.display="none"
    setSelectedCalendars((current) => {
      if (current.includes(calendarId)) {
        return current.filter(
          (id) => id !== calendarId
        );
      }

      return [...current, calendarId];
    });
  };

  return (
    <div className="calendar-selector">
      <div className="calendarLabels">
      {calendars.map((calendar) => (
        <label key={calendar.id}>
          <input
            type="checkbox"
            checked={selectedCalendars.includes(
              calendar.id
            )}
            onChange={() =>
              handleChange(calendar.id)
            }
          />
          {calendar.label}
        </label>
      ))}
      </div>
<div className="calendarToggleBox">
<button  className={`calendarToggle ${
    calendarView === "month" ? "active" : ""}`} 
    onClick={() => setCalendarView("month")}>
  Month
</button>

<button  className={`calendarToggle ${
    calendarView === "day" ? "active" : ""}`}
    onClick={() => {
    setSelectedDate(new Date());
    setCalendarView("day");}}
>
  Today
</button>
<button  className={`calendarToggle ${
    calendarView === "week" ? "active" : ""}`} 
    onClick={() => setCalendarView("week")}>
  Week
</button>
</div>
    </div>
  );
}

export default CalendarSelector;